export const getTenantDefaultChannels = /* GraphQL */ `
  query GetTenant($id: ID!) {
    getTenant(id: $id) {
      id
      group
      defaultCommunicationChannels
    }
  }
`;